module.exports = __webpack_public_path__ + "img/刀.df41b2d3.gif";